import type { Action, GameObject, Rule, SceneContent } from "./types.ts";
export const objectDefaults = (name = "Объект"): GameObject => ({
  id: crypto.randomUUID(),
  name,
  kind: "rect",
  parentId: null,
  entityId: null,
  imageId: null,
  x: 100,
  y: 100,
  width: 80,
  height: 80,
  rotation: 0,
  opacity: 1,
  locked: false,
  states: [],
  state: null,
  shadow: 0,
  animations: [],
  layer: 0,
  active: true,
  visible: true,
  color: "violet",
  text: "Текст",
  player: false,
  solid: false,
  pickup: false,
  trigger: false,
  interactable: false,
  dash: false,
  control: "wasd",
  speed: null,
  dashDistance: null,
  dashCooldown: 0.8,
  interactionRadius: 100,
  bindings: { speed: null, dashDistance: null },
});
export const actionDefaults = (type: Action["type"] = "win"): Action => ({
  type,
  variable: "",
  targetId: "$event",
  targetIds: [],
  sceneId: "",
  value:
    type === "win"
      ? "Победа!"
      : type === "lose"
        ? "Поражение"
        : type === "state" || type === "play"
          ? ""
          : type === "frame"
            ? "instant"
            : 0,
});
export const ruleDefaults = (targetId = ""): Rule => ({
  id: crypto.randomUUID(),
  name: "Новое правило",
  enabled: true,
  event: "interact",
  targetId,
  key: "KeyE",
  detail: "",
  seconds: 1,
  repeat: false,
  conditions: [],
  actions: [actionDefaults()],
  elseActions: [],
});
export function demoScene(
  entityId: string | null = null,
  speedField: string | null = null,
): SceneContent {
  const player = {
      ...objectDefaults("Игрок"),
      entityId,
      x: 100,
      y: 500,
      width: 40,
      height: 40,
      player: true,
      dash: true,
      bindings: { speed: speedField, dashDistance: null },
    },
    wall = {
      ...objectDefaults("Препятствие"),
      x: 420,
      y: 280,
      width: 420,
      height: 60,
      solid: true,
      color: "gray" as const,
    },
    exit = {
      ...objectDefaults("Выход"),
      x: 1130,
      y: 90,
      width: 60,
      height: 60,
      interactable: true,
      color: "green" as const,
    },
    hud = {
      ...objectDefaults("Счётчик кристаллов"),
      kind: "text" as const,
      x: 35,
      y: 25,
      width: 850,
      height: 45,
      text: "Кристаллы: {crystals} / 3 · WASD · Space: рывок · E: выход",
      color: "gray" as const,
    };
  const crystals = [
    { x: 200, y: 130 },
    { x: 1000, y: 560 },
    { x: 820, y: 110 },
  ].map((p, i) => ({
    ...objectDefaults(`Кристалл ${i + 1}`),
    ...p,
    kind: "circle" as const,
    width: 26,
    height: 26,
    pickup: true,
    color: "amber" as const,
  }));
  const pickup = {
    ...ruleDefaults("$any"),
    name: "Подобрать кристалл",
    event: "pickup" as const,
    actions: [
      { ...actionDefaults("add"), variable: "crystals", value: 1 },
      { ...actionDefaults("destroy"), targetId: "$event" },
    ],
  };
  const win = {
    ...ruleDefaults(exit.id),
    name: "Открыть выход",
    conditions: [
      {
        kind: "variable" as const,
        variable: "crystals",
        targetId: "",
        operator: "gte" as const,
        value: 3,
        compare: "value" as const,
        other: "",
      },
    ],
    actions: [
      { ...actionDefaults("win"), value: "Победа! Все кристаллы собраны." },
    ],
  };
  return {
    width: 1280,
    height: 720,
    objects: [wall, ...crystals, exit, player, hud],
    variables: [
      { name: "crystals", type: "number", scope: "project", value: 0 },
    ],
    rules: [pickup, win],
  };
}
